import { InjectionToken } from '@angular/core';

export async function loadConfigurations(url: string): Promise<string> {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Load configuration error: ${response.statusText}`);
  }

  return response.json();
}

export const MBS_APP_CONFIG = new InjectionToken<string>('MbsAppConfig');
